// src/services/coursesApi.js
// 🎓 TICKET VMCJD4 - API pública de cursos para alumnos
// Consume endpoints: GET /api/courses y GET /api/courses/:courseId

import apiClient from './apiClient';

/**
 * Obtiene lista de cursos publicados (solo metadata, sin modules)
 * Endpoint: GET /api/courses
 * 
 * @returns {Promise<Array>} Array de cursos con: courseId, title, shortDescription, estimatedHours, skills, updatedAt
 * @throws {Error} Si falla la llamada al backend
 */
export const getPublishedCourses = async () => {
  try {
    const response = await apiClient.get('/courses');
    return response.data; // Array de cursos
  } catch (error) {
    console.error('[coursesApi] Error al obtener cursos publicados:', error);
    throw error;
  }
};

/**
 * Obtiene detalle completo de un curso publicado (con modules y activities)
 * Endpoint: GET /api/courses/:courseId
 * 
 * @param {string} courseId - ID del curso
 * @returns {Promise<Object>} Curso completo con modules[]
 * @throws {Error} Si falla la llamada al backend (404 si no está publicado o no existe)
 */
export const getPublishedCourseById = async (courseId) => {
  try {
    const response = await apiClient.get(`/courses/${courseId}`);
    return response.data; // Objeto curso con modules
  } catch (error) {
    console.error(`[coursesApi] Error al obtener curso ${courseId}:`, error);
    throw error;
  }
};
